import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Credentials.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

export default function Credentials() {
  const navigate = useNavigate();


  const handleDownloadCredential = (credentialType) => {
    alert(`Downloading ${credentialType}...`);
  };

  const handleVerifyCredential = (credentialType) => {
    alert(`Verifying ${credentialType}...`);
  };

  return (
    <div className="credentials-page page-with-header">
      <Header />
      
      <div className="credentials-container">
        {/* Header */}
        <div className="credentials-header">
          <h1>My Credentials</h1>
          <p>View and manage your professional credentials and certifications</p>
        </div>

        {/* What are Credentials Section */}
        <div className="credentials-info-section">
          <h2>What are Credentials?</h2>
          <div className="info-cards">
            <div className="info-card">
              <h3>🎓 Educational Credentials</h3>
              <p>Degrees, diplomas, and academic qualifications that demonstrate your educational background and expertise in your field.</p>
            </div>
            <div className="info-card">
              <h3>📜 Professional Certifications</h3>
              <p>Industry-recognized certifications that validate your skills and knowledge in specific areas of practice.</p>
            </div>
            <div className="info-card">
              <h3>🏥 Licenses & Permits</h3>
              <p>Official licenses and permits required to practice in your profession, issued by regulatory bodies.</p>
            </div>
            <div className="info-card">
              <h3>📚 Continuing Education</h3>
              <p>Ongoing training, workshops, and courses that keep your knowledge current and up-to-date.</p>
            </div>
          </div>
        </div>

        {/* Current Credentials */}
        <div className="current-credentials">
          <h2>My Current Credentials</h2>
          <div className="credentials-grid">
            <div className="credential-card">
              <div className="credential-header">
                <h3>Bachelor of Psychology</h3>
                <span className="status verified">✓ Verified</span>
              </div>
              <div className="credential-details">
                <p><strong>Institution:</strong> University of Mental Health</p>
                <p><strong>Year:</strong> 2020</p>
                <p><strong>Grade:</strong> First Class Honours</p>
                <p><strong>Credential ID:</strong> PSY-BA-2020-001</p>
              </div>
              <div className="credential-actions">
                <button 
                  className="download-btn"
                  onClick={() => handleDownloadCredential('Bachelor Degree')}
                >
                  📄 Download
                </button>
                <button 
                  className="verify-btn"
                  onClick={() => handleVerifyCredential('Bachelor Degree')}
                >
                  🔍 Verify
                </button>
              </div>
            </div>

            <div className="credential-card">
              <div className="credential-header">
                <h3>Mental Health Counselor License</h3>
                <span className="status verified">✓ Verified</span>
              </div>
              <div className="credential-details">
                <p><strong>Issuing Authority:</strong> Vietnam Mental Health Board</p>
                <p><strong>Issue Date:</strong> March 2021</p>
                <p><strong>Expiry Date:</strong> March 2026</p>
                <p><strong>License Number:</strong> MHC-VN-2021-456</p>
              </div>
              <div className="credential-actions">
                <button 
                  className="download-btn"
                  onClick={() => handleDownloadCredential('Counselor License')}
                >
                  📄 Download
                </button>
                <button 
                  className="verify-btn"
                  onClick={() => handleVerifyCredential('Counselor License')}
                >
                  🔍 Verify
                </button>
              </div>
            </div>

            <div className="credential-card">
              <div className="credential-header">
                <h3>CBT Certification</h3>
                <span className="status pending">⏳ Pending</span>
              </div>
              <div className="credential-details">
                <p><strong>Certifying Body:</strong> International CBT Institute</p>
                <p><strong>Course Completed:</strong> December 2023</p>
                <p><strong>Exam Status:</strong> Passed</p>
                <p><strong>Certificate ID:</strong> CBT-INT-2023-789</p>
              </div>
              <div className="credential-actions">
                <button 
                  className="download-btn"
                  onClick={() => handleDownloadCredential('CBT Certification')}
                >
                  📄 Download
                </button>
                <button 
                  className="verify-btn"
                  onClick={() => handleVerifyCredential('CBT Certification')}
                >
                  🔍 Verify
                </button>
              </div>
            </div>

            <div className="credential-card">
              <div className="credential-header">
                <h3>Trauma-Informed Care Training</h3>
                <span className="status verified">✓ Verified</span>
              </div>
              <div className="credential-details">
                <p><strong>Provider:</strong> National Trauma Institute</p>
                <p><strong>Completion Date:</strong> August 2023</p>
                <p><strong>Hours:</strong> 40 hours</p>
                <p><strong>Certificate ID:</strong> TIC-NTI-2023-123</p>
              </div>
              <div className="credential-actions">
                <button 
                  className="download-btn"
                  onClick={() => handleDownloadCredential('Trauma Training')}
                >
                  📄 Download
                </button>
                <button 
                  className="verify-btn"
                  onClick={() => handleVerifyCredential('Trauma Training')}
                >
                  🔍 Verify
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Add New Credential */}
        <div className="add-credential-section">
          <h2>Add New Credential</h2>
          <div className="add-credential-card">
            <p>Have a new credential to add? Upload your certificate or document to keep your profile up-to-date.</p>
            <button className="add-credential-btn">
              + Add New Credential
            </button>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}
